import * as types from './types';

export default {
  [types.RULE_TYPES]: (state) => state.ruleTypes,
  [types.RULES]: (state) => state.rules,
  [types.RULES_BY_GROUP]: (state) => state.rulesByGroup,
  [types.SEARCH_RESULTS]: (state) => state.searchResults,
  [types.RULE_VIOLATION]: (state) => state.ruleViolation,
};
